import { pageSelectorGenerator } from '@test/pageSelectors';

export const PaymentMethodSelectors = pageSelectorGenerator('PaymentMethod', ['ContainerElement', 'SelectPaymentMethodButton']);
